import { ref, computed } from '@vue/composition-api'
import CustomerApi from '@/api/waiter/Customer'
import { handleApiError } from '@/utils/errorHandler'

export const THRESHOLD_OPTIONS = [
  { value: 30, text: '30日以上' },
  { value: 60, text: '60日以上' },
  { value: 90, text: '90日以上' },
]

export default function useChurnRisk(vm) {
  const customers = ref([])
  const summary = ref({
    totalAtRiskCount: 0,
    highValueAtRiskCount: 0,
  })
  const loading = ref(false)
  const thresholdDays = ref(30)
  const asOfDate = ref(null)

  const hasAtRiskCustomers = computed(() => summary.value.totalAtRiskCount > 0)

  const fetchChurnRisk = async ({ threshold = 30 } = {}) => {
    loading.value = true
    try {
      const res = await CustomerApi.getChurnRisk({
        thresholdDays: threshold,
      })

      thresholdDays.value = res.data.thresholdDays
      asOfDate.value = res.data.asOfDate
      summary.value = res.data.summary || {
        totalAtRiskCount: 0,
        highValueAtRiskCount: 0,
      }
      customers.value = res.data.customers || []

      return {
        summary: summary.value,
        customers: customers.value,
      }
    } catch (error) {
      handleApiError(error, { $toast: vm.$toast })

      return {
        summary: { totalAtRiskCount: 0, highValueAtRiskCount: 0 },
        customers: [],
      }
    } finally {
      loading.value = false
    }
  }

  const getThresholdLabel = threshold => {
    const found = THRESHOLD_OPTIONS.find(t => t.value === threshold)

    return found ? found.text : `${threshold}日以上`
  }

  return {
    customers,
    summary,
    loading,
    thresholdDays,
    asOfDate,
    hasAtRiskCustomers,
    fetchChurnRisk,
    getThresholdLabel,
    THRESHOLD_OPTIONS,
  }
}
